import '@/shared/i18n/instance';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { router } from './router';
import { InspectorDevButton } from '@/shared/components/InspectorDevButton';
import { suppressAgGridLicenseConsoleError, suppressThreeClockDeprecationWarning } from '@/shared/bootstrap/error-wrapper';
import { initCockpitEmbedNavigation } from './embed/cockpit-embed-navigation';
import { applyImpersonationFromIframeUrl } from './embed/impersonation-bootstrap';
import { AppBootstrap } from './providers/AppBootstrap';
import { getSignedReadUrl } from '@/entities/document/api/file-signed-url.api';
import { configureDurableJobTrayActions } from '@/entities/durable-job/lib/durableJobTrayActions';
import { readEffectiveImpersonatedUserId, restoreRamReturnRouteIfNeeded } from '@/shared/utils/impersonation-storage';
import '@/shared/styles/index.css';

configureDurableJobTrayActions({ getSignedReadUrl });

applyImpersonationFromIframeUrl();
// After unimpersonate reload: restore the admin's previous page (Cockpit `__COCKPIT_RETURN_ROUTE__` pattern).
restoreRamReturnRouteIfNeeded(!!readEffectiveImpersonatedUserId());
initCockpitEmbedNavigation(to => void router.navigate(to));

suppressAgGridLicenseConsoleError();
suppressThreeClockDeprecationWarning();

const App = import.meta.env.DEV ? (
    <InspectorDevButton>
        <AppBootstrap />
    </InspectorDevButton>
) : (
    <AppBootstrap />
);

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode>{App}</React.StrictMode>);
